/**
 * Transport Types
 *
 * Type definitions for event transport/car assignments.
 */

/**
 * Available transport modes
 */
export type TransportMode = 'car' | 'bus' | 'train' | 'walk' | 'bike' | 'other';

/**
 * Transport assignment for an event
 */
export type TransportAssignment = {
  id: string;
  mode: TransportMode;
  vehicleName?: string;           // e.g., "Mom's Car", "Family Van"
  driverFamilyMemberId?: string;  // Family member who is driving
  passengerFamilyMemberIds: string[]; // Family members being transported
  notes?: string;
};

/**
 * Transport mode display configuration
 */
export type TransportModeConfig = {
  mode: TransportMode;
  label: string;
  icon: string; // Ionicons icon name
};

/**
 * Available transport modes with display configuration
 */
export const TRANSPORT_MODES: TransportModeConfig[] = [
  { mode: 'car', label: 'Car', icon: 'car-outline' },
  { mode: 'bus', label: 'Bus', icon: 'bus-outline' },
  { mode: 'train', label: 'Train', icon: 'train-outline' },
  { mode: 'walk', label: 'Walk', icon: 'walk-outline' },
  { mode: 'bike', label: 'Bike', icon: 'bicycle-outline' },
  { mode: 'other', label: 'Other', icon: 'ellipsis-horizontal-outline' },
];

/**
 * Get transport mode configuration by mode
 */
export function getTransportModeConfig(mode: TransportMode): TransportModeConfig {
  return TRANSPORT_MODES.find(m => m.mode === mode) || TRANSPORT_MODES[0];
}
